import styled from 'styled-components'

import { NavigationSectionStyled } from './NavigationSectionStyled'

/**
 * Sets the Discover more promotional entry apart from the rest of the nav: a
 * rule above it and a fern fill that holds through hover and the active state.
 * Nesting under this wrapper outranks the single-class `:hover` / `.active`
 * rules NavigationLinkStyled declares for itself.
 */
export const NavigationDiscoverMoreSectionStyled = styled(
  NavigationSectionStyled
)`
  border-top: 1px solid ${(props) => props.theme.colors.content.border};

  padding-top: ${(props) => props.theme.typography.pxToRem(24)};
`
